
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/verification",
      function () {
        return require("private-next-pages/dashboard/verification/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/verification"])
      });
    }
  